import { Component } from '@angular/core';
import { Skeleton } from 'excellence-ui';

@Component({
  selector: 'app-organization-card-skeleton',
  imports: [Skeleton],
  templateUrl: './organization-card-skeleton.html',
})
export class OrganizationCardSkeleton {}
